/**
 * Copyright 2025 IBM Corp.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as R from "remeda";

export type Primitive = string | number | symbol | bigint | boolean | null | undefined;
export function isPrimitive(value: unknown): value is Primitive {
  return (
    R.isString(value) ||
    R.isNumber(value) ||
    R.isBoolean(value) ||
    R.isNullish(value) ||
    R.isSymbol(value)
  );
}
